const SS_KEY = 'gg_rt'

function isSecureStorageAvailable() {
    try {
        const tg = window.Telegram?.WebApp
        return !!(tg?.isVersionAtLeast?.('9.0') && tg?.SecureStorage)
    } catch (e) {
        return false
    }
}

export function saveRefreshToken(token) {
    if (!token) return
    if (!isSecureStorageAvailable()) return
    try {
        window.Telegram.WebApp.SecureStorage.setItem(SS_KEY, token)
    } catch (e) { /* ignore */ }
}

export function getSecureRefreshToken() {
    return new Promise((resolve) => {
        if (!isSecureStorageAvailable()) return resolve(null)
        let resolved = false
        const timeout = setTimeout(() => {
            if (!resolved) { resolved = true; resolve(null) }
        }, 3000)
        try {
            window.Telegram.WebApp.SecureStorage.getItem(SS_KEY, (err, value) => {
                if (!resolved) {
                    resolved = true
                    clearTimeout(timeout)
                    resolve(err ? null : (value || null))
                }
            })
        } catch (e) {
            if (!resolved) { resolved = true; clearTimeout(timeout); resolve(null) }
        }
    })
}

export function clearSecureRefreshToken() {
    if (!isSecureStorageAvailable()) return
    try {
        window.Telegram.WebApp.SecureStorage.removeItem(SS_KEY)
    } catch (e) { /* ignore */ }
}
